import { useMutation } from '@tanstack/react-query';
import { deleteGoals } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const useDeleteGoalsMutation = () =>
  useMutation({
    mutationFn: async (ids: ID[]) => deleteGoals(ids),
  });
